import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import contactForm from "@/modules/blocks/contact-form/index";
import modalShow from "@/modules/containers/modal/modal";
import video from "@/modules/accessability-exp-10743/video/video";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import "slick-carousel/slick/slick";
import { bindJQuery } from "@/scripts/helpers/library";
import { CLASSES } from "@/scripts/helpers/constants";
import actionsCounters from "@/modules/actions-counters/index";

bindJQuery();

const reviewSlider = () => {
  const slider = $(".review-slider");
  const nextArrow = $(".js-slider-arrow .btn-next-arrow");
  const prevArrow = $(".js-slider-arrow .btn-prev-arrow");

  slider.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1;
    const sumCounter = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      nextArrow.removeClass("is-disable");
    } else if (counter === sumCounter) {
      nextArrow.addClass("is-disable");
      prevArrow.removeClass("is-disable");
    } else {
      nextArrow.removeClass("is-disable");
      prevArrow.removeClass("is-disable");
    }
  });

  slider.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 200,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    dsf: false,
    dots: true,
    swipe: false,
    fade: true,
    cssEase: "ease-in",
    responsive: [
      {
        breakpoint: 959,
        settings: {
          swipe: true
        }
      }
    ]
  });

  nextArrow.click(function(e) {
    slider.slick("slickNext");
  });
  prevArrow.click(function(e) {
    slider.slick("slickPrev");
  });
};

const countersRating = () => {
  const countElements = $(".js-counter");
  let hasSuccess = false;

  if (countElements.length) {
    $(window).on("scroll load", function() {
      if (!hasSuccess && countElements.inView()) {
        countElements.each(function() {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).text()
              },
              {
                duration: 3000,
                easing: "swing",
                step: function(now) {
                  if ($(this).text() === "99.99") {
                    setTimeout(() => {
                      $(this).text("99.99");
                    }, 1);
                  }

                  if ($(this).text() === "1,2") {
                    return;
                  }

                  $(this).text(
                    Math.floor(now)
                      .toString()
                      .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                  );
                }
              }
            );
        });
        hasSuccess = true;
      }
    });
  }
};

const headerStickyCustom = () => {
  const heightBody = document.documentElement.scrollTop;
  const headerShadow = document.querySelector(".js-header-shadow");
  const headerBar = document.querySelector(".page-header");

  if (headerShadow) {
    if (heightBody) {
      headerShadow.classList.add("header-box-shadow");
      headerBar.classList.add("is-active");
    } else {
      headerShadow.classList.remove("header-box-shadow");
    }
  }
};

window.addEventListener("scroll", headerStickyCustom);

$(document).ready(function() {
  addedLazyLoadImages();
  video();
  contactForm();
  modalShow();
  initWowLibrary();
  reviewSlider();
  countersRating();
  headerStickyCustom();
  actionsCounters();

  $(window).resize(headerStickyCustom);

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });

  setTimeout(() => {
    $(".intro-illustration__item--arrow").css("visibility", "visible");
  }, 1800);
});
